import { render } from "./CIS-Content-Gray-Box.vue?vue&type=template&id=4d57a278&scoped=true"
import script from "./CIS-Content-Gray-Box.vue?vue&type=script&lang=js"
export * from "./CIS-Content-Gray-Box.vue?vue&type=script&lang=js"

import "./CIS-Content-Gray-Box.vue?vue&type=style&index=0&id=4d57a278&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d57a278"]])

export default __exports__